/** Movement eligibility shared by the scene preview and the browser walk planner. */
export interface OverrunProfile {
  sizeRank?: number | null;
  sizeExemption?: number | null;
  ethereal?: boolean;
  cannotStop?: boolean;
}

import { BROWSER_ONLY_SOLID_PASSAGE_STATUSES } from '../ability/browser-only-layers.js';
/** Both sides use the same passage exemptions, including the scene's preview profiles. */
export const OVERRUN_PASSAGE_STATUS_KEYS = ['ethereal', ...BROWSER_ONLY_SOLID_PASSAGE_STATUSES] as const;

export function requiresOverrun(mover: OverrunProfile, target: OverrunProfile): boolean {
  if (mover.ethereal || target.ethereal || target.cannotStop) return false;
  if (typeof mover.sizeExemption === 'number' && Number.isFinite(mover.sizeExemption)
    && typeof mover.sizeRank === 'number' && mover.sizeRank >= 0
    && typeof target.sizeRank === 'number' && target.sizeRank >= 0
    && target.sizeRank - mover.sizeRank <= mover.sizeExemption) return false;
  return true;
}
